module.exports = __webpack_public_path__ + "static/media/0328_IMG_LES_STRUCTURES_ILV.a5c00ca0.webp";